import { Box, Fade, Grid, LinearProgress } from '@mui/material';
import { SCUIContent } from '../../atomic/organisms';
import React, { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { SCUINoRecordComponent } from '../../atomic/atoms';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import Swal from 'sweetalert2';
import { SCUIBreadCrumb, SCUICustomDataGrid, SCUITextFieldWithButton } from '../../atomic/molecules';
import ProductTransferCommand from '../../services/command/productTransfer/ProductTransferCommand.services';
import ProductTransferQuery from '../../services/query/productTransfer/ProductTransferQuery.services';
import { PT } from './productTransfer.classes';

export const ProductTransfer: FC<any> = () => {
    const { t } = useTranslation();
    const [modelID, setModelId] = useState(0);
    const [response1, setResponse1] = useState(false);
    const [loading, setLoading] = React.useState(false);
    const val1 = true;
    const val2 = true;
    const val3 = true;
    const [datas, setDatas] = React.useState<any>();

    const ProcessModelWithComponentsByModelId = async () => {
        let myArray = [];
        myArray.push(Number(modelID));

        ProductTransferCommand.ProcessModelWithComponentsByModelId(myArray)
            .then(() => {
                ProduceEpimProductToSyncQueue();
            })
            .catch((error: any) => {
                Swal.fire(t('general.error'), ' ', 'error');
                console.log('Hata :>> ', error);
                setLoading(false);
            });
    };
    const ProduceEpimProductToSyncQueue = async () => {
        try {
            await ProductTransferQuery.ProduceEpimProductToSyncQueue().then(() => ConsumeEpimProductQueueForKafka());
        } catch (error) {
            console.log('Hata :>> ', error);
            setLoading(false);
        }
    };
    const ConsumeEpimProductQueueForKafka = async () => {
        try {
            await ProductTransferQuery.ConsumeEpimProductQueueForKafka().then(() => {
                Swal.fire('İşlem Başarılı.', ' ', 'success');
                setLoading(false);
            });
        } catch (error) {
            console.log('Hata :>> ', error);
            setLoading(false);
        }
    };

    const AllOnClick = () => {
        setLoading(true);
        let tempArr: any = [];
        if ((val1 === val2) === val3) {
            setResponse1(true);
        } else {
            setResponse1(false);
        }
        let my_json = { modelID: modelID, response: response1 };
        tempArr = [...tempArr, my_json];
        setDatas(tempArr);
        ProcessModelWithComponentsByModelId();
    };
    return (
        <SCUIContent className={PT.page}>
            <Box className={PT.loadingSection}>
                <Fade in={loading} unmountOnExit>
                    <LinearProgress className={PT.loadingBar} />
                </Fade>
            </Box>
            <div className={PT.breadcrumbSection}>
                <SCUIBreadCrumb title={'Ürün Bilgi Transferi'} componentLink={'ProductTransfer'} />
            </div>
            <Grid className={PT.formSection} container>
                <SCUITextFieldWithButton
                    buttonText={'Bilgi Gönder'}
                    placeholder={'ModelId'}
                    paperClassName={PT.sendPaper}
                    inputClassName={PT.sendInput}
                    buttonClassName={PT.sendButton}
                    buttonSx={{
                        padding: '8px 16px !important',
                    }}
                    onChange={(event: any) => {
                        setModelId(event.target.value);
                    }}
                    onClick={() => AllOnClick()}
                    onKeyPress={(e: any) => {
                        if (e.key === 'Enter') {
                            e.preventDefault();
                            AllOnClick();
                            setLoading(true);
                        }
                    }}
                />

                {datas ? (
                    <Grid className={PT.resultsSection} container direction="row" sx={{ marginLeft: '0.5rem' }}>
                        <Grid
                            className={PT.resultsTitleWrap}
                            sx={{ margin: '1rem' }}
                            size={{
                                xl: 9,
                                lg: 9,
                                md: 6,
                                xs: 6,
                            }}
                        >
                            <h1 className={[PT.resultsTitle, 'headtxt'].join(' ')}>{t('general.searchResults')}</h1>
                        </Grid>
                        <Box className={PT.resultsLoadingWrap}>
                            <Fade in={loading} unmountOnExit>
                                <LinearProgress className={PT.loadingBar} />
                            </Fade>
                        </Box>

                        <Grid
                            className={PT.resultsGridWrap}
                            size={{
                                sm: 12,
                                md: 12,
                                lg: 12,
                                xl: 12,
                            }}
                        >
                            <SCUICustomDataGrid
                                randomId
                                rows={datas}
                                columns={[
                                    { field: 'modelID', headerName: 'Model Id', flex: 1 },
                                    {
                                        field: 'response',
                                        headerName: 'Response',
                                        minWidth: 200,
                                        flex: 1,
                                        renderCell: (params: any) => {
                                            if (params.row.response) {
                                                return (
                                                    <CheckCircleIcon
                                                        color="success"
                                                        className={[PT.cellResponseIconSuccess, 'svg_icons'].join(' ')}
                                                    />
                                                );
                                            } else
                                                return (
                                                    <CancelIcon
                                                        color="error"
                                                        className={[PT.cellResponseIconError, 'svg_icons'].join(' ')}
                                                    />
                                                );
                                        },
                                    },
                                ]}
                            />
                        </Grid>
                    </Grid>
                ) : (
                    <SCUINoRecordComponent />
                )}
            </Grid>
        </SCUIContent>
    );
};
